<template>
  <i18n-link
    :class="$style.root"
    :to="{
      name: routeName,
      params: { slug: data?.slug },
      query: route?.query
    }"
    :data-active="active ? '' : null"
    v-animated-underline-mouse-events
  >
    <div
      :class="$style.heading"
    >
      <shared-edition-animated-title-component
        :title="data?.title?.trim()"
        :active="active"
        class="animated-underline"
      />
      <span
        v-if="data?.titleAnnotation"
        v-html="`, ${data?.titleAnnotation?.trim()}`"
        :class="$style.titleAnnotation"
      />
    </div>

    <div
      :class="$style.information"
    >
      <span
        v-if="!data?.hideDates"
      >
        <core-date-time-range-component :date-start="data?.dateStart" :date-end="data?.dateEnd" />{{ country ? ', ' : '' }}
      </span>

      <span
        v-if="country"
      >
        {{ country }}
      </span>
    </div>
  </i18n-link>
</template>

<script lang="ts" setup>
const route = useRoute()
const nuxtApp = useNuxtApp()

const props = defineProps({
  data: Object,
  active: {
    type: Boolean,
    default: false
  }
})

const routeName = computed(() => getRouteName() === 'editions' ? 'editions-slug-index-about' : getRouteName())

const country = props.data.country ? i18nCountryNameForCode(props.data.country) : null
</script>

<style module>
.root {
  composes: reset-link font-size-large from global;
  display: block;
  margin: auto;
  text-align: center;
}

.root[data-active] {
  pointer-events: none;
}

.heading {
  composes: reset-heading from global;
  color: var(--color--primary);
}

.titleAnnotation {
  text-transform: lowercase;
  display: inline;
}

.information {
  color: var(--color--secondary);
}
</style>
